<template>
  <section class="fighter-hero">
    <div class="container full-width-small">

      <div class="video-aspect" :class="{mobile: mobileDevice}" aria-hidden="true">
        <div class="aspect-content">

          <video :key="fighter.name" autoplay muted loop class="fighter-video" :poster="poster">
            <source :src="video" type="video/mp4">
          </video>
          <img :src="image" class="fighter-logo" :alt="fighter.name" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import isMobile from '@/constants/isMobile.js';

export default {
  name: 'FighterHero',
  props: ['fighter'],
  data() {
    return {
      mobileDevice: isMobile()
    }
  },
  computed: {
    image() {
      return this.fighter.fighter_logo;
    },
    video() {

      if(this.mobileDevice) {

        return '';
      } else {

        return this.fighter.fighter_video_hero.video_background;
      }
    },
    poster() {

      if(this.mobileDevice) {

        return this.fighter.fighter_video_hero.video_background_fallback;
      } else {

        return this.fighter.fighter_video_hero.video_background_plate;
      }
    }
  }
};
</script>

<style lang="scss">

.fighter-hero {
  background: #000;

  .fighter-logo {
    max-width: 80%;
    display: block;
    position: absolute;
    left: 50%;
    bottom: 20vw;
    transform: translate3d(-50%,0,0);
    transition: opacity .5s ease-in-out;

    @include bp($bp--m) {
      max-width: 100%;
      bottom: 5vw;
      left: 0;
      bottom: 50%;
      transform: translate3d(0,50%,0);

    }
  }

  .video-aspect {
    @include aspect-ratio(1,0.75);

    @include bp($bp--m) {
      @include aspect-ratio(16,9);
    }

    .fighter-logo {
      max-width: 33%;

      @include bp($bp--m) {
        max-width: 44%;
      }
    }

    // MOBILE OVERRIDE
    &.mobile {
      @include aspect-ratio(3,4.5);

      @include bp($bp--m) {
        @include aspect-ratio(3,3);
      }

      .fighter-logo {
        max-width: 80%;

        @include bp($bp--m) {
          max-width: 100%;
        }
      }
    }
  }
  .fighter-video {
    position: absolute;
    top: 0;
    width: 100%;
  }
}

// Fighter specific overrides
.fighter-empot {

  .fighter-logo {
    @include bp($bp--m) {
      max-width: 100%;
      left: 0;
      bottom: 0;
      transform: translate3d(0,-50%,0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/fighters/FighterHero.vue